import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ErrorOutline, HourglassEmpty, Print } from '@material-ui/icons';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  useQuizAssessmentTestDataProvider
} from "../../../providers/data-provider/quiz-assessment-test.data.provider";

const POLLING_INTERVAL_MS = 3000;
const FINAL_STATUSES = ['done', 'error'];

const useStyles = makeStyles(() => ({
  pendingButton: {
    '&.Mui-disabled': {
      borderColor: '#9e9e9e',
      color: '#9e9e9e',
    },
  },
  processingButton: {
    '&.Mui-disabled': {
      borderColor: '#ff9800',
      color: '#ff9800',
    },
  },
  errorButton: {
    borderColor: '#f44336',
    color: '#f44336',
  },
}));

export function PrintTest({ availabilityId, userContextId, studentName, testId, documentStatus }) {
  const classes = useStyles();
  const { printTest, pubPrintTest, getTestDocument } = useQuizAssessmentTestDataProvider();
  const [printing, setPrinting] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [status, setStatus] = useState(documentStatus);
  const pollingRef = useRef(null);

  if (testId === 'dd484a62-f726-4e07-a6b3-3f8f6350a3a5') {
    console.log(documentStatus);
  }
  useEffect(() => {
    getTestDocument(testId)
        .then(({ data }) => {
          const nextStatus = data?.status;
          if (!nextStatus) return;
          setStatus(nextStatus);
        })
  }, [testId]);

  useEffect(() => {
    setStatus(documentStatus);
  }, [documentStatus]);

  const stopPolling = useCallback(() => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  }, []);

  const startPolling = useCallback(() => {
    stopPolling();
    let fetching = false;
    pollingRef.current = setInterval(() => {
      if (fetching) return;
      fetching = true;
      getTestDocument(testId)
        .then(({ data }) => {
          const nextStatus = data?.status;
          if (!nextStatus) return;
          setStatus(nextStatus);
          if (FINAL_STATUSES.includes(nextStatus)) {
            stopPolling();
          }
        })
        .catch(() => {})
        .finally(() => { fetching = false; });
    }, POLLING_INTERVAL_MS);
  }, [getTestDocument, testId, stopPolling]);

  useEffect(() => stopPolling, [stopPolling]);

  const handleDownload = () => {
    setDownloading(true);
    printTest(availabilityId, userContextId, studentName, testId).finally(() => setDownloading(false));
  };

  const pubPrintRequest = () => {
    setPrinting(true);
    startPolling();
    setStatus('processing');
    pubPrintTest(availabilityId, userContextId).finally(() => setPrinting(false));
  }

  if (!status || status === 'pending') {
    return (
        <Button
            variant="outlined"
            size="small"
            className={classes.pendingButton}
            startIcon={printing ? <CircularProgress size={16} color="inherit" /> : <HourglassEmpty />}
            onClick={pubPrintRequest}
        >
          Gerar Avaliação
        </Button>
    );
  }

  if (status === 'processing') {
    return (
        <Button
            variant="outlined"
            size="small"
            className={classes.processingButton}
            startIcon={<CircularProgress size={16} color="inherit" />}
            disabled
        >
          Avaliação Sendo Gerada
        </Button>
    );
  }

  if (status === 'error') {
    return (
        <Button
            variant="outlined"
            size="small"
            className={classes.errorButton}
            startIcon={<ErrorOutline />}
            disabled
        >
          Erro na Geração
        </Button>
    );
  }

  return (
      <Button
          variant="outlined"
          size="small"
          startIcon={downloading ? <CircularProgress size={16} color="inherit" /> : <Print />}
          onClick={handleDownload}
          disabled={printing}
      >
        Baixar Avaliação
      </Button>
  );
}
